module.exports = __webpack_public_path__ + "img/010.fb72a79a.jpg";